"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Award, Calendar } from "lucide-react";
export default function Leadership() {
  const shouldReduceMotion = useReducedMotion();
  return <section data-nav="light" id="lãnh-đạo-hội" className="w-full bg-background py-8 md:py-12">
      {/* Fallback anchor target for english routing if referenced */}
      <span id="leadership" className="sr-only" />

      <div className="container mx-auto max-w-5xl px-4 sm:px-6">
        <motion.div initial={{
        opacity: 0,
        y: shouldReduceMotion ? 0 : 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.38,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative overflow-hidden rounded-sm border border-border bg-card p-6 shadow-xs md:p-8">
          {/* Accent left border bar */}
          <div className="absolute top-0 bottom-0 left-0 w-1 bg-primary" />

          <div className="flex flex-col items-center gap-6 sm:items-start md:flex-row md:gap-8">
            {/* Left Column: Portrait */}
            <div className="shrink-0">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1803866/img/chu-tich-pham-van-khiem-2.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1803866/img/chu-tich-pham-van-khiem-2.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1803866/img/chu-tich-pham-van-khiem-2.png-wvc-sizes" alt="Chân dung Chủ tịch Hội Phạm Văn Khiêm" loading="lazy" decoding="async" className="size-32 rounded-full border border-border object-cover shadow-sm md:size-40" />
            </div>

            {/* Right Column: Information Stack */}
            <div className="flex flex-1 flex-col">
              <span className="text-xs font-semibold tracking-wider text-muted-foreground uppercase">
                Lãnh đạo Hội
              </span>

              <h2 className="mt-1 text-lg font-semibold text-foreground">
                Chủ tịch Hội: Phạm Văn Khiêm
              </h2>

              <p className="mt-2 text-sm leading-relaxed text-foreground">
                Chịu trách nhiệm điều hành toàn diện hoạt động của Hội, định hướng
                chiến lược phát triển và đại diện Hội trong các quan hệ đối ngoại,
                hợp tác trong nước và quốc tế.
              </p>

              {/* Quote Block */}
              <blockquote className="my-4 border-l-2 border-primary pl-4 text-sm italic text-muted-foreground">
                "Hội Địa lý Môi trường Việt Nam ra đời với mong muốn tập hợp những người cùng chung một mối quan tâm: sống hài hòa với thiên nhiên và xây dựng một tương lai bền vững cho đất nước. Chúng tôi tin rằng khoa học địa lý và môi trường không chỉ là nghiên cứu, mà còn là con đường để mỗi người hiểu hơn về nơi mình đang sống và có trách nhiệm hơn với nó. Trong chặng đường phía trước, Hội sẽ tiếp tục đồng hành cùng các nhà khoa học, chuyên gia và cộng đồng để lan tỏa những giá trị này rộng rãi hơn nữa."
              </blockquote>

              {/* Info Badges */}
              <div className="flex flex-col gap-3 rounded-sm border border-border bg-muted/40 p-4 text-xs text-muted-foreground sm:flex-row sm:items-center sm:gap-6">
                <div className="flex items-center gap-2">
                  <SafeHydrate><Calendar className="size-4 shrink-0 text-primary" /></SafeHydrate>
                  <span>
                    <strong className="font-medium text-foreground">
                      Nhiệm kỳ:
                    </strong>{" "}
                    2021 - 2026
                  </span>
                </div>

                <div className="hidden h-3.5 w-px bg-border sm:block" />

                <div className="flex items-center gap-2">
                  <Award className="size-4 shrink-0 text-primary" />
                  <span>
                    <strong className="font-medium text-foreground">
                      Cơ sở pháp lý:
                    </strong>{" "}
                    Quyết định số 483/QĐ-BNV
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}